module.exports = __webpack_public_path__ + "static/media/isdoctorplan-oncology3.3965b9ed.png";